import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Fiscais de contrato',
    defaultMessage: 'Fiscais de contrato',
  },
  formTitle: {
    id: 'Título',
    defaultMessage: 'Título',
  },
});

export const fiscaisSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title'],
      },
    ],
    properties: {
      title: {
        title: props.intl.formatMessage(messages.formTitle),
      },
    },
    required: ['title'],
  };
};
